import type { StateParams } from '@uirouter/angularjs';
import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';

export const $stateParamsToken = upgradeExternalNg1Dependency<StateParams>('$stateParams');
